import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CollectionCaseCompositeEntity } from '@nk/data-entities-lib';
import { AccountsNumberPipe } from '../../../../pipes/accounts-number.pipe';
import { getCompanyPaymentRemarkTableItem } from '../../../../utils/company-payment-remarks.utils';

@Component({
  selector: 'nk-company-payment-remarks-table',
  templateUrl: './company-payment-remarks-table.component.html',
  imports: [DatePipe, TranslateModule, AccountsNumberPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyPaymentRemarksTableComponent {
  public collectionCaseCompositeEntities = input<CollectionCaseCompositeEntity[]>();
  public printVersion = input(false);

  public entities = computed(() => {
    const value = this.collectionCaseCompositeEntities();
    return Array.isArray(value) ? value.map((i) => getCompanyPaymentRemarkTableItem(i)) : null;
  });
}
